var confirmationModal = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		$(target).on('click', 'a[data-toggle=confirmation], button[data-toggle=confirmation]', function(e) {

			var element = $(this);

			e.preventDefault();

			var title = element.data('confirmation-title');
			var content = element.data('confirmation-content');
			var size = element.data('confirmation-size');

			var defaultTarget = element.attr('href');

			if (size === undefined) {
				size = '';
			}
			$('#generalModal .modal-dialog').removeAttr('class').addClass('modal-dialog').addClass('modal-' + size);

			if (title === undefined) {
				title = $('#generalModal .modal-title').data('confirmation-default-title');
			}

			$('#generalModal .modal-title').html(title);

			$('#generalModal .modal-body').html(content);

			$('#generalModal .modal-footer').removeClass('d-none');

			var btnCancelLabel = element.data('btn-cancel-label');
			var btnCancelClass = element.data('btn-cancel-class');

			var btnOkLabel = element.data('btn-ok-label');
			var btnOkClass = element.data('btn-ok-class');

			var btnAltLabel = element.data('btn-alt-label');
			var btnAltClass = element.data('btn-alt-class');
			var btnAltTarget = element.data('btn-alt-target');

			if (btnCancelLabel === undefined) {
				btnCancelLabel = $('#generalModal #generalModalBtnCancel').data('confirmation-default-label');
			}

			if (btnCancelClass === undefined) {
				btnCancelClass = 'btn-secondary';
			}

			$('#generalModal #generalModalBtnCancel').html(btnCancelLabel).removeAttr('class').addClass('btn').addClass(btnCancelClass);

			if (btnOkLabel === undefined) {
				btnOkLabel = $('#generalModal #generalModalBtnOk').data('confirmation-default-label');
			}

			if (btnOkClass === undefined) {
				btnOkClass = 'btn-secondary';
			}

			$('#generalModal #generalModalBtnOk').html(btnOkLabel).removeAttr('class').addClass('btn').addClass(btnOkClass);

			$('#generalModal #generalModalBtnOk').unbind('click').click(function() {
				if (defaultTarget !== undefined) {
					window.location.href = defaultTarget;
				} else {
					element.closest('form').submit();
				}
			});

			if (btnAltClass === undefined) {
				btnAltClass = 'btn-secondary';
			}

			if (btnAltTarget === undefined) {
				btnAltTarget = '';
			}

			if (btnAltLabel !== undefined) {
				$('#generalModal #generalModalBtnAlt').html(btnAltLabel).removeAttr('class').addClass('btn').addClass(btnAltClass);
				$('#generalModal #generalModalBtnAlt').unbind('click').click(function() {
					window.location.href = btnAltTarget;
				});
			}

			$('#generalModal').modal('show', {
				keyboard: false,
				backdrop: 'static'
			});

		});

	}

};

export default confirmationModal;
